import { Icon } from "@blueprintjs/core";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface ComponentOptionalInputProps {
  optional: boolean;
  onChange?: (optional: boolean) => void;
}

export function OptionalFormInput({
  optional,
  onChange,
}: ComponentOptionalInputProps) {
  return (
    <div className="flex items-center gap-3">
      <input
        type="checkbox"
        checked={optional}
        className="h-5 w-5 rounded border border-gray-400"
        onChange={(event) => onChange?.(event.target.checked)}
      />
      <div className="flex items-center gap-1">
        <span
          className="cursor-pointer select-none"
          onClick={() => onChange?.(!optional)}
        >
          This component is optional
        </span>
        <Tooltip>
          <TooltipTrigger asChild>
            <Icon icon="info-sign" className="text-prompt" />
          </TooltipTrigger>
          <TooltipContent className="text-pretty" side="bottom">
            Participants can skip this component and still complete the program
            successfully.
          </TooltipContent>
        </Tooltip>
      </div>
    </div>
  );
}
